import * as React from 'react'
const PendingIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path d="M7 10a.47.47 0 00-.28.09.43.43 0 00-.19.52.41.41 0 00.13.25.45.45 0 00.24.14.48.48 0 00.29 0 .58.58 0 00.23-.18.53.53 0 00-.06-.64A.54.54 0 007 10zm0-.93a.31.31 0 00.31-.31V3.22a.31.31 0 00-.62 0v5.54a.31.31 0 00.31.31z" className="-primary-color" fill="#a5aab8"/>
      <path d="M7 12.6a5.56 5.56 0 01-5.17-3.46A5.58 5.58 0 0110.93 3a5.5 5.5 0 01.69.84A5.6 5.6 0 017 12.6zM7 2a5 5 0 00-2.77.84A5.06 5.06 0 002.4 5.1a5 5 0 006.5 6.5 5.08 5.08 0 002.24-1.83A5 5 0 007 2z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default PendingIcon